<template>


    <nav class="cf-menutop" ref="menuroot">
        <div class="cf-menu-inner">

            <!-- Bascule mobile -->
            <button @click="toggleNavbar" type="button" class="cf-menu-burger" :aria-expanded="isNavbarOpen.toString()">
                <span class="sr-only">Ouvrir le menu</span>
                <i class="ri-menu-line"></i>
            </button>

            <div :class="{ 'hidden': !isNavbarOpen, 'block': isNavbarOpen }" class="cf-menu-collapse" id="navbar-dropdown">
                <ul class="cf-menu-list">

                    <!-- Tiers -->
                    <li v-permission="'commercial.tiers'" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'tiers' }" @click="toggleMenu('tiers')">
                            <i class="ri-team-line cf-menu-icon"></i> Tiers
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'tiers' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'tiers'" class="cf-menu-pop">
                                <button type="button" v-permission="'commercial.tiers.client'" class="cf-menu-item" @click="btnmodalclt('clt'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-user-3-line"></i> Clients
                                </button>
                                <button type="button" v-permission="'commercial.tiers.fournisseur'" class="cf-menu-item" @click="btnmodalclt('frs'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-truck-line"></i> Fournisseurs
                                </button>
                                <button type="button" v-permission="'commercial.tiers.collaborateur'" class="cf-menu-item" @click="btnmodalclt('col'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-user-star-line"></i> Collaborateur
                                </button>
                            </div>
                        </transition>
                    </li>

                    <!-- Achat -->
                    <li v-permission="'commercial.achats'" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'achat' }" @click="toggleMenu('achat')">
                            <i class="ri-shopping-bag-3-line cf-menu-icon"></i> Achat
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'achat' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'achat'" class="cf-menu-pop cf-menu-scroll">
                                <button type="button" v-permission="'commercial.achats.demande'" class="cf-menu-item" @click="btnmodaldefaultachatvente('DAF','achat'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-file-add-line"></i> Demande d'achat
                                </button>
                                <button type="button" v-permission="'commercial.achats.commande'" class="cf-menu-item" @click="btnmodaldefaultachatvente('BCF','achat'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-shopping-basket-2-line"></i> Bon de commande
                                </button>
                                <button type="button" v-permission="'commercial.achats.reception'" class="cf-menu-item" @click="btnmodaldefaultachatvente('BRF','achat'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-inbox-archive-line"></i> Bon de réception
                                </button>
                                <button type="button" v-permission="'commercial.achats.facture'" class="cf-menu-item" @click="btnmodaldefaultachatvente('FR','achat'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-bill-line"></i> Facture
                                </button>
                                <button type="button" v-permission="'commercial.achats.consolidationfacture'" class="cf-menu-item" @click="btnmodaldefaultachatvente('FRG','achat'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-stack-line"></i> Consolidation des documents pour la facturation
                                </button>
                                <button type="button" v-permission="'commercial.achats.avoir'" class="cf-menu-item" @click="btnmodaldefaultachatvente('RF','achat'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-arrow-go-back-line"></i> Retours sur achats
                                </button>
                            </div>
                        </transition>
                    </li>

                    <!-- Vente -->
                    <li v-permission="'commercial.ventes'" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'vente' }" @click="toggleMenu('vente')">
                            <i class="ri-hand-coin-line cf-menu-icon"></i> Vente
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'vente' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'vente'" class="cf-menu-pop cf-menu-scroll">
                                <button type="button" v-permission="'commercial.ventes.devis'" class="cf-menu-item" @click="btnmodaldefaultachatvente('PF','vente'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-draft-line"></i> Devis
                                </button>
                                <button type="button" v-permission="'commercial.ventes.commande'" class="cf-menu-item" @click="btnmodaldefaultachatvente('BC','vente'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-shopping-basket-2-line"></i> Bon de commande
                                </button>
                                <button type="button" v-permission="'commercial.ventes.preparation'" class="cf-menu-item" @click="btnmodaldefaultachatvente('BPL','vente'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-archive-drawer-line"></i> Bon de préparation de livraison
                                </button>
                                <button type="button" v-permission="'commercial.ventes.livraison'" class="cf-menu-item" @click="btnmodaldefaultachatvente('BL','vente'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-truck-line"></i> Bon de livraison
                                </button>
                                <button type="button" v-permission="'commercial.ventes.facture'" class="cf-menu-item" @click="btnmodaldefaultachatvente('F','vente'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-bill-line"></i> Facture
                                </button>
                                <button type="button" v-permission="'commercial.ventes.consolidationfacturevente'" class="cf-menu-item" @click="btnmodaldefaultachatvente('FG','vente'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-stack-line"></i> Consolidation des documents pour la facturation
                                </button>
                                <button type="button" v-permission="'commercial.ventes.retour'" class="cf-menu-item" @click="btnmodaldefaultachatvente('BR','vente'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-arrow-go-back-line"></i> Retours sur vente
                                </button>
                                <button type="button" v-permission="'commercial.ventes.avoir'" class="cf-menu-item" @click="btnmodaldefaultachatvente('FA','vente'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-refund-2-line"></i> Facture d'avoir
                                </button>
                                <button type="button" v-permission="'commercial.ventes.avoirfinancier'" class="cf-menu-item cf-menu-item--muted" disabled>
                                    <i class="ri-refund-line"></i> Facture d'avoir financière <span class="cf-menu-soon">Bientôt</span>
                                </button>
                            </div>
                        </transition>
                    </li>

                    <!-- Rapports -->
                    <li v-permission="'commercial.etats'" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'rap' }" @click="toggleMenu('rap')">
                            <i class="ri-bar-chart-box-line cf-menu-icon"></i> Rapports
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'rap' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'rap'" class="cf-menu-pop">
                                <button type="button" class="cf-menu-item" @click="btnmodalhistoriquedocument(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-history-line"></i> Historique des documents commerciaux
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalpointarticleparbon(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-article-line"></i> Rapports des articles par bon
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalrapportsurvente(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-line-chart-line"></i> Rapports sur ventes
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalrapportsurachat(); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-bar-chart-line"></i> Rapports sur achats
                                </button>
                            </div>
                        </transition>
                    </li>

                </ul>
            </div>
        </div>
    </nav>


    <modalfrsclt ref="modalfrsclt"></modalfrsclt>
    <modaldefaultachatvente ref="modaldefaultachatvente"></modaldefaultachatvente>
    <modalhistoriquedocument ref="modalhistoriquedocument"></modalhistoriquedocument>
    <modalrapportsurvente ref="modalrapportsurvente"></modalrapportsurvente>
    <modalrapportsurachat ref="modalrapportsurachat"></modalrapportsurachat>
    <modalpointarticleparbon ref="modalpointarticleparbon"></modalpointarticleparbon>

</template>


<script>
    import modalfrsclt from "@/components/views/pages/gestioncommerciale/frscltcolb/index";
    import modaldefaultachatvente from "@/components/views/pages/gestioncommerciale/achatvente/default/index";
    import modalhistoriquedocument from "@/components/views/pages/gestioncommerciale/rapport/modal_historiquedocument";
    import modalrapportsurvente from "@/components/views/pages/gestioncommerciale/rapport/modal_rapportsurvente";
    import modalrapportsurachat from "@/components/views/pages/gestioncommerciale/rapport/modal_rapportsurachat";

    import modalpointarticleparbon from "@/components/views/pages/comptabilite/editions/modal_point_article_parbon";


    export default {
        /* eslint-disable */
        name: "mymenu",
        data() {
            return {
                isNavbarOpen: false,
                isDropdownOpen: true,
                openMenu: null
            };
        },
        components: {
            modalfrsclt,

            modaldefaultachatvente,
            modalpointarticleparbon,
            modalhistoriquedocument,
            modalrapportsurvente,
            modalrapportsurachat,
        },
        methods: {

            btnmodalpointarticleparbon() {

                this.$refs.modalpointarticleparbon.show();

            },

            btnmodalrapportsurvente(){

                let titlemodal ="Historique des documents commerciaux";

                this.$refs.modalrapportsurvente.show(titlemodal);
            },

            btnmodalrapportsurachat(){

                let titlemodal ="Historique des documents commerciaux";

                this.$refs.modalrapportsurachat.show(titlemodal);
            },

            btnmodalhistoriquedocument(){

                let titlemodal ="Historique des documents commerciaux";

                this.$refs.modalhistoriquedocument.show(titlemodal);
            },




            btnmodalclt(value){

                let titlemodal


                if (value==='clt'){
                    titlemodal="Liste des clients"
                }

                if (value==='frs'){
                    titlemodal="Liste des fournisseurs"
                }

                if (value==='col'){
                    titlemodal="Liste des collaborateurs"
                }


                this.$refs.modalfrsclt.show(titlemodal,value);
            },




            btnmodaldefaultachatvente(value,typededocument){

                let titlemodal


                if (value==='DAF'){
                    titlemodal="Liste des demandes d'achat"
                }

                if (value==='BCF'){
                    titlemodal="Liste des bons de commande fournisseur"
                }

                if (value==='BRF'){
                    titlemodal="Liste des bons de réception fournisseur"
                }

                if (value==='FR'){
                    titlemodal="Liste des factures d'avoir client"

                                     }

                if (value==='FRG'){
                    titlemodal="Liste des factures consolidées (fournisseur)"
                }

                if (value==='RF'){
                    titlemodal="Liste des bons de retour fournisseur"
                }

                if (value==='PF'){
                    titlemodal="Liste des devis"
                }

                if (value==='BC'){
                    titlemodal="Liste des bon de commande client"
                }

                if (value==='BPL'){
                    titlemodal="Liste des bons de préparation de livraison"
                }

                if (value==='BL'){
                    titlemodal="Liste des bons de livraisson clients"
                }

                if (value==='F'){
                    titlemodal="Liste des factures clients"
                }

                if (value==='FG'){
                    titlemodal="Liste des factures consolidées (clients)"
                }

                if (value==='BR'){
                    titlemodal="Liste des bons de retour clients"
                }

                if (value==='FA'){
                    titlemodal="Liste des factures d'avoir clients"
                }

                if (value==='FRF'){
                    mname="Liste des factures d'avoir FRS"
                }




                this.$refs.modaldefaultachatvente.show(titlemodal,value,typededocument);
            },







            toggleNavbar() {
                this.isNavbarOpen = !this.isNavbarOpen;
            },
            toggleDropdown() {
                console.log("1122")

                this.isDropdownOpen = !this.isDropdownOpen;

                console.log("1122 this.isDropdownOpen ",this.isDropdownOpen)
            },

            // Plumbing menus manuels (remplace Preline hs-dropdown)
            toggleMenu(name) {
                this.openMenu = this.openMenu === name ? null : name;
            },
            handleGlobalClick(e) {
                const root = this.$refs.menuroot;
                if (root && !root.contains(e.target)) {
                    this.openMenu = null;
                }
            }
        },

        mounted() {
            document.addEventListener('click', this.handleGlobalClick);
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleGlobalClick);
        }
    };
</script>

<style scoped>
    /* Charte cf-/ds- : barre de menu du module Gestion commerciale (light-only) */
    .cf-menutop {
        margin-top: 4% !important;
        background: #fff;
        border: 1px solid rgb(var(--default-border));
        border-radius: var(--cf-radius);
        box-shadow: var(--cf-shadow-sm);
    }
    @media screen and (max-width: 800px) { .cf-menutop { margin-top: 12.5% !important; } }

    .cf-menu-inner {
        display: flex; flex-wrap: wrap; align-items: center; gap: 0.5rem 1rem;
        padding: 0.6rem 1rem; max-width: 1280px; margin: 0 auto;
    }

    .cf-menu-burger {
        margin-left: auto; height: 38px; width: 38px; border: 1px solid var(--cf-border);
        border-radius: var(--cf-radius-sm); background: #fff; color: var(--cf-muted);
        display: inline-flex; align-items: center; justify-content: center; font-size: 1.2rem; cursor: pointer;
    }
    .cf-menu-burger:hover { color: rgb(var(--primary)); border-color: rgb(var(--primary) / 0.35); }
    @media (min-width: 768px) { .cf-menu-burger { display: none; } }

    .cf-menu-collapse { width: 100%; }
    @media (min-width: 768px) { .cf-menu-collapse { display: block !important; width: auto; margin-left: auto; } }

    .cf-menu-list {
        display: flex; flex-direction: column; gap: 0.2rem; list-style: none;
        margin: 0.6rem 0 0; padding: 0;
    }
    @media (min-width: 768px) {
        .cf-menu-list { flex-direction: row; align-items: center; justify-content: flex-end; gap: 0.4rem; margin: 0; }
    }

    .cf-menu-dd { position: relative; }

    .cf-menu-btn {
        display: inline-flex; align-items: center; gap: 0.35rem; width: 100%;
        padding: 0.5rem 0.75rem; border-radius: var(--cf-radius-sm);
        font-weight: 600; font-size: 0.85rem; color: var(--cf-ink);
        background: transparent; border: 0; cursor: pointer; text-align: left;
        transition: color 0.18s ease, background-color 0.18s ease;
    }
    @media (min-width: 768px) { .cf-menu-btn { width: auto; } }
    .cf-menu-btn:hover { color: rgb(var(--primary)); background: rgb(var(--primary) / 0.07); }
    .cf-menu-btn--on { color: rgb(var(--primary)); background: rgb(var(--primary) / 0.10); }
    .cf-menu-icon { color: rgb(var(--primary)); font-size: 1rem; }
    .cf-menu-caret { margin-left: auto; font-size: 0.9rem; color: var(--cf-faint); transition: transform 0.18s ease; }
    @media (min-width: 768px) { .cf-menu-caret { margin-left: 0.15rem; } }
    .cf-menu-caret--on { transform: rotate(180deg); color: rgb(var(--primary)); }

    .cf-menu-pop {
        display: flex; flex-direction: column; gap: 1px;
        margin: 0.15rem 0 0.35rem 0.75rem; padding: 0.35rem;
        border-left: 2px solid var(--cf-border);
    }
    @media (min-width: 768px) {
        .cf-menu-pop {
            position: absolute; top: calc(100% + 6px); right: 0; left: auto; z-index: 40;
            min-width: 260px; margin: 0; padding: 0.4rem;
            background: #fff; border: 1px solid var(--cf-border); border-left: 1px solid var(--cf-border);
            border-radius: var(--cf-radius); box-shadow: var(--cf-shadow-md);
        }
    }
    .cf-menu-scroll { max-height: 70vh; overflow-y: auto; }
    @media (min-width: 768px) { .cf-menu-scroll { min-width: 320px; } }

    .cf-menu-item {
        display: flex; align-items: center; gap: 0.5rem; width: 100%;
        padding: 0.5rem 0.65rem; border-radius: var(--cf-radius-sm);
        font-size: 0.82rem; font-weight: 500; color: var(--cf-ink);
        background: transparent; border: 0; cursor: pointer; text-align: left;
        transition: background-color 0.15s ease, color 0.15s ease;
    }
    .cf-menu-item i { color: var(--cf-muted); font-size: 1rem; flex-shrink: 0; }
    .cf-menu-item:hover { background: rgb(var(--primary) / 0.08); color: rgb(var(--primary)); }
    .cf-menu-item:hover i { color: rgb(var(--primary)); }
    .cf-menu-item--muted { color: var(--cf-faint); cursor: not-allowed; }
    .cf-menu-item--muted:hover { background: transparent; color: var(--cf-faint); }
    .cf-menu-item--muted:hover i { color: var(--cf-muted); }

    .cf-menu-soon {
        margin-left: auto; flex-shrink: 0;
        padding: 0.1rem 0.45rem; border-radius: 999px;
        font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.02em;
        color: rgb(var(--primary)); background: rgb(var(--primary) / 0.10);
        border: 1px solid rgb(var(--primary) / 0.25);
    }

    .cf-menu-fade-enter-active, .cf-menu-fade-leave-active { transition: opacity 0.15s ease, transform 0.15s ease; }
    .cf-menu-fade-enter-from, .cf-menu-fade-leave-to { opacity: 0; transform: translateY(-4px); }

    .sr-only {
        position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
        overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
    }

    button:focus { outline: 0 !important; }
</style>
